import React from 'react';
import "./footer.scss"

import AxisButton from '../button/button';
import Text from '../typography/typgraphy';
import { COPYRIGHT_MESSAGE, DISCLAIMER, PRIVACY_POLICY } from '../../constants/messages';

const Footer = () => {
  return (
    <React.Fragment>
      <div className="footer-container">
        <div className="footer-wrapper">
          <div className={"copyright-wrapper"}>
            <Text className={"copyright-text"}>{COPYRIGHT_MESSAGE}</Text>
          </div>
          <div className="privacy-wrapper">
            <AxisButton customStyle={"hyperlink-btn"} href="https://www.axisbank.com/disclaimer">
              <Text className={"privacy-text"}>
                {DISCLAIMER}
              </Text>
            </AxisButton>
            <Text className={"privacy-text-separator"}>&nbsp;&nbsp;|&nbsp;&nbsp;</ Text>
            <AxisButton customStyle={"hyperlink-btn"} href="https://www.axisbank.com/privacy-policy">
              <Text className={"privacy-text"}>
                {PRIVACY_POLICY}
              </Text>
            </AxisButton>
          </div>
        </div>
      </div>
    </React.Fragment >
  )
}

export default Footer;
